import Vue from 'vue'
import Router from 'vue-router'
import is_mobile from "./utils/isMobile";

Vue.use(Router);


const originalPush = Router.prototype.push;
Router.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err)
}

// pc 端路由
const PCRoutes = [
  {
    path: '/pc',
    component: () => import('./views/PCViews/PCHome.vue'),
    children: [
      {
        path: '/pc/home',
        name: 'pc-home',
        component: () => import('./views/PCViews/Home.vue'),
        meta: {
          title: '绿色金融60人论坛',
          enTit: 'Green Finance Forum of 60'
        }
      }, {
        path: '/us/pc/home',
        name: 'pc-home',
        component: () => import('./views/PCViews/Home.vue'),
        meta: {
          title: '绿色金融60人论坛',
          enTit: 'Green Finance Forum of 60'
        }
      }, {
        path: '/pc/about',
        name: 'pc-about',
        component: () => import('./views/PCViews/About.vue'),
        meta: {
          title: '关于我们-绿色金融60人论坛',
          enTit: 'About US-Green Finance Forum of 60'
        }
      }, {
        path: '/us/pc/about',
        name: 'pc-about',
        component: () => import('./views/PCViews/About.vue'),
        meta: {
          title: '关于我们-绿色金融60人论坛',
          enTit: 'About US-Green Finance Forum of 60'
        }
      }, {
        path: '/pc/forum',
        name: 'pc-forum',
        component: () => import('./views/PCViews/Forum.vue'),
        meta: {
          title: '关于我们-绿色金融60人论坛',
          enTit: 'About US-Green Finance Forum of 60'
        }
      }, {
        path: '/us/pc/forum',
        name: 'pc-forum',
        component: () => import('./views/PCViews/Forum.vue'),
        meta: {
          title: '关于我们-绿色金融60人论坛',
          enTit: 'About US-Green Finance Forum of 60'
        }
      }, {
        path: '/pc/news/:type',
        name: 'pc-news',
        component: () => import('./views/PCViews/News.vue'),
        meta: {
          title: '新闻动态-绿色金融60人论坛',
          enTit: 'Information-Green Finance Forum of 60'
        }
      }, {
        path: '/us/pc/news/:type',
        name: 'pc-news',
        component: () => import('./views/PCViews/News.vue'),
        meta: {
          title: '新闻动态-绿色金融60人论坛',
          enTit: 'Information-Green Finance Forum of 60'
        }
      }, {
        path: '/pc/activity/seminars',
        name: 'pc-activity-seminars',
        component: () => import('./views/PCViews/Seminars.vue'),
        meta: {
          title: '专业研讨-绿色金融60人论坛',
          enTit: 'Seminars-Green Finance Forum of 60'
        }
      },
      {
        path: '/pc/activity/submit',
        name: 'pc-activity-submit',
        component: () => import('./views/PCViews/Activity.vue'),
        meta: {
          title: '年度峰会-绿色金融60人论坛',
          enTit: 'Seminars-Green Finance Forum of 60'
        }
      },
      {
        path: '/us/pc/activity/seminars',
        name: 'pc-activity-seminars',
        component: () => import('./views/PCViews/Seminars.vue'),
        meta: {
          title: '专业研讨-绿色金融60人论坛',
          enTit: 'Seminars-Green Finance Forum of 60'
        }
      },
      {
        path: '/us/pc/activity/submit',
        name: 'pc-activity-submit',
        component: () => import('./views/PCViews/Activity.vue'),
        meta: {
          title: '年度峰会-绿色金融60人论坛',
          enTit: 'Seminars-Green Finance Forum of 60'
        }
      },
      {
        path: '/pc/result/report',
        name: 'pc-result',
        component: () => import('./views/PCViews/Result.vue'),
        meta: {
          title: '研究成果-绿色金融60人论坛',
          enTit: 'Research-Green Finance Forum of 60'
        }
      }, {
        path: '/us/pc/result/report',
        name: 'pc-result',
        component: () => import('./views/PCViews/Result.vue'),
        meta: {
          title: '研究成果-绿色金融60人论坛',
          enTit: 'Research-Green Finance Forum of 60'
        }
      },
      {
        path: '/pc/result/journal',
        name: 'pc-result',
        component: () => import('./views/PCViews/Journal.vue'),
        meta: {
          title: '研究成果-绿色金融60人论坛',
          enTit: 'Research-Green Finance Forum of 60'
        }
      }, {
        path: '/us/pc/result/journal',
        name: 'pc-result',
        component: () => import('./views/PCViews/Journal.vue'),
        meta: {
          title: '研究成果-绿色金融60人论坛',
          enTit: 'Research-Green Finance Forum of 60'
        }
      },
      {
        path: '/pc/expert',
        name: 'pc-expert',
        component: () => import('./views/PCViews/Expert.vue'),
        meta: {
          title: '专家委员会-绿色金融60人论坛',
          enTit: 'Experts-Green Finance Forum of 60'
        }
      }, {
        path: '/us/pc/expert',
        name: 'pc-expert',
        component: () => import('./views/PCViews/Expert.vue'),
        meta: {
          title: '专家委员会-绿色金融60人论坛',
          enTit: 'Experts-Green Finance Forum of 60'
        }
      }, {
        path: '/pc/detail/:id',
        name: 'pc-detail',
        component: () => import('./views/PCViews/ArticleDetail'),
        meta: {
          title: '文章详情-绿色金融60人论坛',
          enTit: 'Content-Green Finance Forum of 60'
        }
      }, {
        path: '/pc/search',
        name: 'pc-search',
        component: () => import('./views/PCViews/SearchPage'),
        meta: {
          title: '搜索结果-绿色金融60人论坛',
          enTit: 'Content-Green Finance Forum of 60'
        }
      }, {
        path: '/us/pc/search',
        name: 'pc-search',
        component: () => import('./views/PCViews/SearchPage'),
        meta: {
          title: '搜索结果-绿色金融60人论坛',
          enTit: 'Content-Green Finance Forum of 60'
        }
      }, {
        path: '/pc/climate-index',
        name: 'pc-climate-index',
        component: () => import('./views/PCViews/ClimateIndex.vue'),
        meta: {
          title: '气候指数-绿色金融60人论坛',
          enTit: 'Climate-index Finance Forum of 60'
        }
      },{
        path: '/us/pc/climate-index',
        name: 'pc-climate-index',
        component: () => import('./views/PCViews/ClimateIndex.vue'),
        meta: {
          title: '气候指数-绿色金融60人论坛',
          enTit: 'Climate-Friendly-index Finance Forum of 60'
        }
      },
      {
        path: '/pc/green-finance-award-2023',
        name: 'pc-gfa2023',
        component: () => import('./views/404'),
        meta: {
          title: 'GF60绿色金融奖评选说明',
          enTit: 'GreenFinanceAward'
        }
      },
      {
        path: '/us/pc/green-finance-award-2023',
        name: 'pc-gfa2023',
        component: () => import('./views/404'),
        meta: {
          title: 'GF60绿色金融奖评选说明',
          enTit: 'GreenFinanceAward'
        }
      },
      {
        path: '/pc/green-finance-award-2024',
        name: 'pc-gfa2024',
        component: () => import('./views/404'),
        meta: {
          title: 'GF60绿色金融案例评选说明',
          enTit: 'GreenFinanceAward'
        }
      },
      {
        path: '/us/pc/green-finance-award-2024',
        name: 'pc-gfa2024',
        component: () => import('./views/404'),
        meta: {
          title: 'GF60绿色金融案例评选说明',
          enTit: 'GreenFinanceAward'
        }
      },
      {
        path: '/pc/*',
        redirect: '/pc/home'
      },{
        path: '/us/pc/*',
        redirect: '/us/pc/home'
      }
    ]
  }
];

// 手机端路由
const MobileRoutes = [
  {
    path: '/mobile',
    component: () => import('./views/MobileViews/MobileHome.vue'),
    children: [
      {
        path: '/mobile/home',
        name: 'mobile-home',
        component: () => import('./views/MobileViews/Home.vue'),
        meta: {
          title: '绿色金融60人论坛',
          enTit: 'Green Finance Forum of 60'
        }
      }, {
        path: '/us/mobile/home',
        name: 'mobile-home',
        component: () => import('./views/MobileViews/Home.vue'),
        meta: {
          title: '绿色金融60人论坛',
          enTit: 'Green Finance Forum of 60'
        }
      }, {
        path: '/mobile/about',
        name: 'mobile-about',
        component: () => import('./views/MobileViews/About.vue'),
        meta: {
          title: '关于我们-绿色金融60人论坛',
          enTit: 'About US-Green Finance Forum of 60'
        }
      }, {
        path: '/us/mobile/about',
        name: 'mobile-about',
        component: () => import('./views/MobileViews/About.vue'),
        meta: {
          title: '关于我们-绿色金融60人论坛',
          enTit: 'About US-Green Finance Forum of 60'
        }
      }, {
        path: '/mobile/forum',
        name: 'mobile-forum',
        component: () => import('./views/MobileViews/Forum.vue'),
        meta: {
          title: '关于我们-绿色金融60人论坛',
          enTit: 'About US-Green Finance Forum of 60'
        }
      }, {
        path: '/us/mobile/forum',
        name: 'mobile-forum',
        component: () => import('./views/MobileViews/Forum.vue'),
        meta: {
          title: '关于我们-绿色金融60人论坛',
          enTit: 'About US-Green Finance Forum of 60'
        }
      }, {
        path: '/mobile/news',
        name: 'mobile-news',
        component: () => import('./views/MobileViews/News.vue'),
        meta: {
          title: '新闻动态-绿色金融60人论坛',
          enTit: 'Information-Green Finance Forum of 60'
        }
      }, {
        path: '/us/mobile/news',
        name: 'mobile-news',
        component: () => import('./views/MobileViews/News.vue'),
        meta: {
          title: '新闻动态-绿色金融60人论坛',
          enTit: 'Information-Green Finance Forum of 60'
        }
      }, {
        path: '/mobile/activity',
        name: 'mobile-activity',
        component: () => import('./views/MobileViews/Activity.vue'),
        meta: {
          title: '论坛活动-绿色金融60人论坛',
          enTit: 'Events-Green Finance Forum of 60'
        }
      }, {
        path: '/us/mobile/activity',
        name: 'mobile-activity',
        component: () => import('./views/MobileViews/Activity.vue'),
        meta: {
          title: '论坛活动-绿色金融60人论坛',
          enTit: 'Events-Green Finance Forum of 60'
        }
      }, {
        path: '/mobile/result',
        name: 'mobile-result',
        component: () => import('./views/MobileViews/Result.vue'),
        meta: {
          title: '论坛成果-绿色金融60人论坛',
          enTit: 'Research-Green Finance Forum of 60'
        }
      }, {
        path: '/us/mobile/result',
        name: 'mobile-result',
        component: () => import('./views/MobileViews/Result.vue'),
        meta: {
          title: '论坛成果-绿色金融60人论坛',
          enTit: 'Research-Green Finance Forum of 60'
        }
      }, {
        path: '/mobile/expert',
        name: 'mobile-expert',
        component: () => import('./views/MobileViews/Expert.vue'),
        meta: {
          title: '专家委员会-绿色金融60人论坛',
          enTit: 'Experts-Green Finance Forum of 60'
        }
      }, {
        path: '/us/mobile/expert',
        name: 'mobile-expert',
        component: () => import('./views/MobileViews/Expert.vue'),
        meta: {
          title: '专家委员会-绿色金融60人论坛',
          enTit: 'Experts-Green Finance Forum of 60'
        }
      }, {
        path: '/mobile/detail/:id',
        name: 'mobile-detail',
        component: () => import('./views/MobileViews/ArticleDetail.vue'),
        meta: {
          title: '文章详情-绿色金融60人论坛',
          enTit: 'Content-Green Finance Forum of 60'
        }
      }, {
        path: '/mobile/search',
        name: 'mobile-search',
        component: () => import('./views/MobileViews/SearchPage'),
        meta: {
          title: '搜索结果-绿色金融60人论坛',
          enTit: 'Content-Green Finance Forum of 60'
        }
      }, {
        path: '/mobile/green-finance-award',
        name: 'mobile-gfa',
        component: () => import('./views/MobileViews/Activities/GreenFinanceAward'),
        meta: {
          title: 'GF60绿色金融奖评选说明',
          enTit: 'GreenFinanceAward'
        }
      },
      {
        path: '/mobile/green-finance-award-2023',
        name: 'mobile-gfa2023',
        component: () => import('./views/MobileViews/Activities/GreenFinanceAward2023'),
        meta: {
          title: 'GF60绿色金融奖评选说明',
          enTit: 'GreenFinanceAward'
        }
      },
      {
        path: '/mobile/green-finance-award-2024',
        name: 'mobile-gfa2024',
        component: () => import('./views/MobileViews/Activities/GreenFinanceAward2024'),
        meta: {
          title: 'GF60绿色金融案例评选说明',
          enTit: 'GreenFinanceAward'
        }
      },
      {
        path: '/mobile/climate-index',
        name: 'pc-climate-index',
        component: () => import('./views/PCViews/ClimateIndex.vue'),
        meta: {
          title: '气候指数-绿色金融60人论坛',
          enTit: 'Climate-index Finance Forum of 60'
        }
      },
      {
        path: '/us/mobile/climate-index',
        name: 'pc-climate-index',
        component: () => import('./views/PCViews/ClimateIndex.vue'),
        meta: {
          title: '气候指数-绿色金融60人论坛',
          enTit: 'Climate-index Finance Forum of 60'
        }
      }, {
        path: '/mobile/summit-meeting',
        name: 'mobile-sm',
        component: () => import('./views/MobileViews/Activities/SummitMeeting/SummitMeeting.vue'),
        meta: {
          title: '专题｜2022绿色金融国际峰会',
          enTit: 'Summit Meeting'
        }
      }, {
        path: '/mobile/summit-meeting-imgs',
        name: 'mobile-sm-img',
        component: () => import('./views/MobileViews/Activities/SummitMeeting/SMImageList'),
        meta: {
          title: '精彩图集',
          enTit: 'Summit Meeting Images'
        }
      }, {
        path: '/mobile/summit-meeting-awards',
        name: 'mobile-sm-img',
        component: () => import('./views/MobileViews/Activities/SummitMeeting/SMAwards'),
        meta: {
          title: '绿金评选',
          enTit: 'Summit Meeting Awards'
        }
      }
    ]
  },{
    path: '/mobile/*',
    redirect: '/mobile/home'
  }, {
    path: '/us/mobile/*',
    redirect: '/us/mobile/home'
  }
];

const router = new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/',
      redirect: is_mobile() ? '/mobile/home' : '/pc/home'
    },
    ...PCRoutes,
    ...MobileRoutes
  ]
});

router.beforeEach((to, from, next) => {
  const lang = is_mobile() ? sessionStorage.getItem('mlang') : sessionStorage.getItem('plang');
  document.title = lang === 'zh' ? to.meta.title : to.meta.enTit;

  const mbFlag = is_mobile();
  const path = to.path;
  const query = to.query;

  if(mbFlag && path.indexOf('pc') >= 0) {
    const newPath = path.replace('pc', 'mobile');
    next({path: newPath, query});
  } else if(!mbFlag && path.indexOf('mobile') >= 0){
    const newPath = path.replace('mobile', 'pc');
    next({path: newPath, query});
  } else {
    next();
  }

  next();
})

export default router
